import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    backgroundColor: 'secondary.main',
    margin: '16px 24px',
    padding: '24px 32px',
  },
  title: {
    fontWeight: '600',
    fontSize: 22,
    color: 'common.grey850',
    mb: '23px',
  },
  crumbContainer: {
    mb: '16px',
  },
  fieldContainer: {
    mb: '8px',
  },
  buttonContainer: {
    marginTop: '24px',
    justifyContent: 'flex-end',
  },
  noUnderline: {
    textDecoration: 'none',
    fontSize: 14,
  },
  prevLink: {
    color: 'grey.500',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
